module.exports = __webpack_public_path__ + "static/media/t_shirts.7a5706ae.jpg";